"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isConnectedComponent = exports.BRIGADE_CONNECT_KEY = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BRIGADE_CONNECT_KEY = '__SECRET_BRIGADE_CONNECTED_COMPONENT__';
exports.BRIGADE_CONNECT_KEY = BRIGADE_CONNECT_KEY;

var isConnectedComponent = function (Component) {
  if (!Component) return false;

  if (_react.default.isValidElement(Component)) {
    return Component.type && Component.type[BRIGADE_CONNECT_KEY] === true;
  }

  return Component[BRIGADE_CONNECT_KEY] === true;
};

exports.isConnectedComponent = isConnectedComponent;